import { Box, Stack } from '@mui/material'
import { FC } from 'react'
import { EmphasizedNumber, GachaTicketThumbnail, IconButton } from 'utoniq-ui'

export type PurchaseProps = {
  ticket: number | string
  src: string
  isPurchasable: boolean
  onPurchase: () => void
}

export const Purchase: FC<PurchaseProps> = ({
  ticket,
  isPurchasable,
  onPurchase,
  src,
}) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      direction="row"
      sx={{
        position: 'relative',
        bgcolor: 'grey.100',
        borderRadius: 3,
        height: 20,
        width: 88,
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 32,
          position: 'absolute',
          left: -12,
        }}
      >
        <GachaTicketThumbnail src={src} />
      </Box>
      <EmphasizedNumber variant="subtitle1">{ticket}</EmphasizedNumber>
      {isPurchasable && (
        <IconButton.Plus
          onClick={onPurchase}
          size="small"
          color="white"
          bgcolor="primary.main"
          sx={{
            width: 24,
            height: 24,
            position: 'absolute',
            right: 0,
            svg: {
              width: 15,
              height: 15,
            },
          }}
        />
      )}
    </Stack>
  )
}
